import React from "react";
import AdminDeliveryZoneManager from "../../components/AdminSideComponents/AdminDeliveryZone/AdminDeliveryZoneManager";

const AdminDeliveryZone = () => {
  return (
    <div>
      <AdminDeliveryZoneManager />
    </div>
  );
};

export default AdminDeliveryZone;
